<template>
	<div class="container">
		<div class="row">
			<div class="col-md-6 offset-md-3">
				<h1>Log In</h1>

				<form @submit.prevent="performLogin()" class="login-form">
					<div class="form-group mt-4">
						<label class="control-label" for="email">Email</label>
						<input id="email" v-model="email" type="email" required="required" class="form-control">
					</div>
					<div class="form-group">
						<label class="control-label" for="password">Password</label>
						<input id="password" v-model="password" type="password" required="required" class="form-control">
					</div>
					<p>
						<router-link to="/forgot">Forgot your password?</router-link>
					</p>
					<!-- <div class="form-group">
						<input id="rememberme" type="checkbox" v-model="rememberme">
						<label class="form-check-label" for="rememberme"> Remember Me</label>
					</div> -->
					<div class="form-group">
						<button type="submit" class="btn btn-primary mt-3">Submit</button>
					</div>

					<div v-if="passwordfail">
						<p class="bold error-text">Sorry, but that email and password combination didn't work. Please try again.</p>
					</div>

				</form>
			</div>
		</div>
	</div>
</template>

<script>
import API from "@/services/api";
export default {
  data() {
    return {
      email: "",
      password: "",
      rememberme: false,
      passwordfail: false
    };
  },
  methods: {
    async performLogin() {
      this.passwordfail = false;
      try {
        await API.Login(this.email, this.password, this.rememberme);
        this.$router.push("/upload" + window.location.search);
      } catch (err) {
        this.passwordfail = true;
      }
    }
  }
};
</script>

<style>
.row {
	display: flex;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue